import { useReveal } from "../hooks/useReveal";

const entries = [
  {
    date: "Now",
    note: "Exploring AI-assisted development workflows and integrating them effectively into new solutions such as Verdance Grow.",
    tag: "Innovating",
  },
  {
    date: "2025",
    note: "Joined Nozomi Networks, maintaining the core SaaS platform and delivering high-impact ideas and features.",
    tag: "Scaling",
  },
  {
    date: "2024",
    note: "Deepened expertise in front-end technologies, design patterns, and small-scale projects. Built software for companies across multiple industries.",
    tag: "Growth",
  },
  {
    date: "2023",
    note: "Completed an M.Sc. in Computer Science and transitioned from academia to delivering production software in a consultancy environment.",
    tag: "Milestone",
  },
];

const BuildLog = () => {
  const [ref, visible] = useReveal(0.1);

  return (
    <section ref={ref} className="w-full bg-stone-900 text-white px-2 md:px-8 border-y-3 border-black">
      <div className="max-w-[1500px] mx-auto py-20 px-4 md:px-12">
        {/* Header */}
        <div className={`flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-12 ${visible ? "reveal-up" : "reveal-hidden"}`}>
          <div>
            <p className="text-2xl font-black uppercase tracking-tight">
              Build Log
              <span className="text-orange-500">.</span>
            </p>
            <div className={`w-16 h-1 bg-orange-600 mt-2 ${visible ? "line-grow delay-200" : "reveal-hidden"}`} />
          </div>
          <p className="text-sm text-gray-400 max-w-[360px]">
            What I'm building, learning, and thinking about. A running log of
            engineering life.
          </p>
        </div>

        {/* Horizontal cards */}
        <div className="flex gap-6 overflow-x-auto pb-4 md:pb-0 md:grid md:grid-cols-4 md:overflow-visible snap-x snap-mandatory">
          {entries.map((entry, i) => (
            <div
              key={i}
              className={`min-w-[260px] md:min-w-0 snap-start flex flex-col border-3 ${
                i === 0
                  ? "border-orange-600 bg-orange-600 text-white"
                  : "border-gray-600 bg-stone-800"
              } ${visible ? `reveal-up delay-${(i + 2) * 100}` : "reveal-hidden"}`}
            >
              {/* Top bar */}
              <div className={`p-4 border-b-3 ${
                i === 0 ? "border-orange-800" : "border-gray-600"
              }`}>
                <span className="text-2xl font-black uppercase tracking-tight block">
                  {entry.date}
                </span>
                <span className={`text-[10px] font-bold uppercase tracking-[0.2em] mt-1 block ${
                  i === 0 ? "text-orange-200" : "text-orange-500"
                }`}>
                  {entry.tag}
                </span>
              </div>
              {/* Note */}
              <div className="p-4 flex-1 flex items-start">
                <p className={`text-sm leading-relaxed ${
                  i === 0 ? "" : "text-gray-300"
                }`}>
                  {entry.note}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BuildLog;
